import { render, staticRenderFns } from "./Attachments.vue?vue&type=template&id=6b5d6ebb&scoped=true"
import script from "./Attachments.vue?vue&type=script&lang=js"
export * from "./Attachments.vue?vue&type=script&lang=js"
import style0 from "./Attachments.vue?vue&type=style&index=0&id=6b5d6ebb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5d6ebb",
  null
  
)

export default component.exports